import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

export const getBaseModalFooterStyles = () => ({
  stepModalFooterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'absolute',
    bottom: 16,
    width: '100%',
  },
  actionsContainer: {
    display: 'flex',
    paddingLeft: 16,
  },
  defaultButton: {
    marginRight: 8,
  },
  skipLink: {
    textDecoration: 'underline',
  },
  stepProgressContainer: {
    marginLeft: 'auto',
  },
});

export const baseModalFooterStyles = {
  stepProgress: {
    root: {
      color: palette.neutralPrimary,
      paddingTop: 5,
    },
  },
};
